import { getOrganizationHelpers } from '@sravni/ugc/lib/organizations/helpers';
import type { TOrganizationTypes } from '@sravni/ugc/lib/organizations/types';

import type { GetBannersParams } from '../__generated__/gateway/gatewayApiTypes';
import { BANNER_TYPES_LIST, RELOADED_BANNERS } from '../constants/advertisment';
import type { DecorateParams } from '../types/advertising';

type MakeBannerParams = {
  isFirstRender: boolean;
  organizationType: TOrganizationTypes;
};

export const makeBannerParams = ({ isFirstRender, organizationType }: MakeBannerParams): GetBannersParams => {
  const { dfpCategory } = getOrganizationHelpers(organizationType);

  return {
    BannerTypes: isFirstRender ? BANNER_TYPES_LIST : RELOADED_BANNERS,
    Category: dfpCategory,
    Product: 'rating',
    Page: 'calculator',
  };
};

export const makeDecorateBannerParams = ({ service }: TFilters): DecorateParams => ({
  ...(service?.alias && { vs: service.alias }),
});
